import '../../../proStoreCategories/index.mjs';
import { UniFiChildCategorySlug, UniFiCategoryId } from '../../../proStoreCategories/mapping/unifi.mjs';
import { SiteId } from '../../../../contexts/MenuContext/mapping.mjs';
import '../../assets/product-list-assets/switches/utility/flex-mini-25G.jpg.mjs';
import '../../assets/Switching/flexMini2_5G.jpg.mjs';
import { productListSwitchingCompact } from '../product-list-groups/productListSwitchingCompact.mjs';
import '../properties/index.mjs';
import { switchTechnology } from '../properties/switchTechnology.mjs';
import { ports } from '../properties/ports.mjs';
import { downlinkSpeed } from '../properties/downlinkSpeed.mjs';
import { uplinkSpeed } from '../properties/uplinkSpeed.mjs';
import { poeOutput } from '../properties/poeOutput.mjs';
import { poeAvailability } from '../properties/poeAvailability.mjs';
import { etherlighting } from '../properties/etherlighting.mjs';
import { proAvSupport } from '../properties/proAvSupport.mjs';
import { powerMethod } from '../properties/powerMethod.mjs';
import { mounting } from '../properties/mounting.mjs';
import { outdoorReady } from '../properties/outdoorReady.mjs';
import v3Image__default from "../../../../assets/flexMini2_5G.jpg";
import image__default from "../../../../assets/flex-mini-25G.jpg";
"use strict";
const flexMini2_5G = {
  id: "flexMini2_5G",
  title: "flexMini2_5G.title",
  techspecsPath: [SiteId.TechSpecs, `/unifi/${UniFiCategoryId.Switching}/usw-flex-2-5g-5`],
  storePathParts: {
    productSlug: "usw-flex-2-5g-5",
    category: UniFiChildCategorySlug.SwitchingUtility
  },
  description: "flexMini2_5G.description",
  image: {
    src: image__default,
    width: 200,
    height: 140
  },
  v3Image: {
    src: v3Image__default,
    width: 243,
    height: 120
  },
  productListGroup: productListSwitchingCompact,
  isNew: true,
  descriptionMaxWidth: 195,
  propertyValues: [{
    propertyId: "dimensions",
    value: {
      type: "string",
      value: '117.1 x 90 x 21.2 mm\n(4.6 x 3.5 x 0.8")'
    }
  }, {
    propertyId: switchTechnology.id,
    value: {
      type: "translation",
      value: "commons.switchingTechnology.layer3"
    }
  }, {
    propertyId: "portCount",
    value: {
      type: "string",
      value: "5"
    }
  }, {
    propertyId: ports.id,
    value: {
      type: "translation",
      value: "flexMini2_5G.ports"
    }
  }, {
    propertyId: downlinkSpeed.id,
    value: {
      type: "translation",
      value: "flexMini2_5G.downlinkSpeed"
    }
  }, {
    propertyId: uplinkSpeed.id,
    value: {
      type: "translation",
      value: "flexMini2_5G.uplinkSpeed"
    }
  }, {
    propertyId: poeOutput.id,
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: poeAvailability.id,
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: etherlighting.id,
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: proAvSupport.id,
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: "generalRedundancy",
    value: {
      type: "boolean",
      value: false
    }
  }, {
    propertyId: powerMethod.id,
    value: {
      type: "translation",
      value: "flexMini2_5G.powerMethod"
    }
  }, {
    propertyId: mounting.id,
    value: {
      type: "translation",
      value: "commons.mounting.desktop"
    }
  }, {
    propertyId: outdoorReady.id,
    value: {
      type: "boolean",
      value: false
    }
  }]
};
export { flexMini2_5G };
//# sourceMappingURL=flexMini2_5G.mjs.map
